import { render, staticRenderFns } from "./AddTournamentBlockCover.vue?vue&type=template&id=7e1b9ff2&"
import script from "./AddTournamentBlockCover.vue?vue&type=script&lang=js&"
export * from "./AddTournamentBlockCover.vue?vue&type=script&lang=js&"
import style0 from "./AddTournamentBlockCover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports